module.exports = __webpack_public_path__ + "static/media/X.76171dc7.jpg";